var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssVar)},[_c('div',{staticClass:"single-data-chart"},[_c('e-chart',{attrs:{"option":_vm.singleOption,"autoresize":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }